import type {
  IAccountingFees,
  IAccountingFeesDetails,
} from "../interfaces/models/IAccountingFees";

export const DEFAULT_ANNUAL_MEETING_REG_FEE = 1000;

export function resolveAnnualMeetingRegFeeFromDoc(
  doc: IAccountingFees | null | undefined,
  legacyAnnualMeetingDoc?: IAccountingFees | null,
): number {
  const detail = doc?.details?.find((d) => d.type === "annualMeetingPrepaid");
  const fromNormal = detail?.fee;
  if (fromNormal !== null && fromNormal !== undefined) {
    const parsed = Number(fromNormal);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }

  const legacyFee = legacyAnnualMeetingDoc?.details?.[0]?.fee;
  if (legacyFee !== null && legacyFee !== undefined) {
    const parsed = Number(legacyFee);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }

  return DEFAULT_ANNUAL_MEETING_REG_FEE;
}

export function resolveAnnualMeetingRegFeeFormValue(
  doc: IAccountingFees | null | undefined,
  legacyAnnualMeetingDoc?: IAccountingFees | null,
): string {
  const detail = doc?.details?.find((d) => d.type === "annualMeetingPrepaid");
  if (detail?.fee !== null && detail?.fee !== undefined) {
    return String(detail.fee);
  }

  const legacyFee = legacyAnnualMeetingDoc?.details?.[0]?.fee;
  if (legacyFee !== null && legacyFee !== undefined) {
    return String(legacyFee);
  }

  return "";
}

export function buildAnnualMeetingRegFeeDetail(
  fee: number,
): IAccountingFeesDetails {
  const amount = Number.isFinite(fee) ? fee : DEFAULT_ANNUAL_MEETING_REG_FEE;
  return {
    type: "annualMeetingPrepaid",
    fee: amount,
    increasePercentage: 0,
  };
}

export function upsertAnnualMeetingRegFeeDetail(
  details: IAccountingFeesDetails[],
  annualMeetingFeeValue: string,
): IAccountingFeesDetails[] {
  const parsed = parseFloat(annualMeetingFeeValue);
  const fee = Number.isFinite(parsed) ? parsed : 0;
  const without = details.filter((d) => d.type !== "annualMeetingPrepaid");
  return [...without, buildAnnualMeetingRegFeeDetail(fee)];
}
